/**
 * Created by Miguel on 23/05/2017
 */
import { Component, HostListener,OnInit, Input, ViewChild,ChangeDetectionStrategy, ViewEncapsulation,SimpleChanges  } from '@angular/core';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { AppDataService }  from '../../services/app-data.service';
import { CompanyService }  from '../../services/company.service';
import {RecipeBean} from "../../beansts/recipe.bean"
import { WalletService }  from '../../services/wallet.services';
import { TranslationService } from '../../services/translation.service';
import { WritBean } from '../../beansts/quests/writ.bean';
import { ActivatedRoute} from '@angular/router';
import { title } from 'process';

declare var $ : any;
declare var Swal: any

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    templateUrl:'shop-modal-component.html',
    providers  : [],

  })
export class ShopPageComponent implements OnInit {
    public ngOnInit() : any {
      

    this._routeParams.queryParams.subscribe(params => {
      var uid = params['uid'];
      var objectId = params['objectId'];
      var kind = params['kind'];
      var room = params['room'];
      this.itens=[]
      this._companyService.getRoom(room).get().then(v=>{
        this._appData.room=v.data();
        this._companyService.getUserByUid(uid).then(v=>{
          this._appData.instagramUser=v.data(); 
      }) 

        if (kind=='shopify'){
          this._companyService.getShopifyItens(1).subscribe(v=>{
            let i=JSON.parse(v['_body']);
            i.products.forEach(it=>{
              let variants=it.variants
              let price=''
              if (variants){
                price=variants[0].price
              }
              let nameVec=it.title.split(' ')
              let url='https://b9183d-5.myshopify.com/products/'
              nameVec.forEach(n=>{
                url=url+n+'-'
              })
              url=url.substring(0,url.length-1);
              this.itens.push({
                thumbnail:it.image ? it.image.src : '',
                name:it.vendor,
                description:it.title,
                url:url,
                price:price
              })
            })
            console.log(i)



          })
        }
      }) 


      })
    }
    public gotoLink(id){
    }
    constructor( public _sanitizer: DomSanitizer,public translate: TranslationService,public _appData : AppDataService, public _companyService: CompanyService,public _walletService: WalletService,public _routeParams : ActivatedRoute) {
    }

    public itens;
    //    $('#npcReload').click();
    public reload(){
    }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/Modals/shop-modal-component.ts